export default "__VITE_ASSET__BRFWh1Mw__"